import React from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase-config";

const AccountDisabled = () => {
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await signOut(auth);
            localStorage.clear();
            navigate("/login");
        } catch (error) {
            console.error("Logout error:", error);
        }
    };

    return (
        <div
            style={{
                minHeight: "100vh",
                background: "#000",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "30px",
            }}
        >
            <div
                style={{
                    maxWidth: "600px",
                    width: "100%",
                    border: "1px solid rgba(255, 204, 0, 0.5)",
                    borderRadius: "12px",
                    padding: "30px",
                    background: "rgba(15, 15, 15, 0.95)",
                    textAlign: "center",
                    boxShadow: "0 0 20px rgba(255, 204, 0, 0.1)",
                }}
            >
                <h1 style={{ color: "#ffcc00", marginBottom: "10px" }}>
                    Account Disabled
                </h1>

                <p style={{ color: "rgba(255,255,255,0.8)", marginBottom: "20px" }}>
                    Your account has been disabled by an administrator.
                    <br />
                    If you believe this is a mistake, please contact support.
                </p>

                <button
                    onClick={handleLogout}
                    style={{
                        background: "#ffcc00",
                        color: "#000",
                        fontWeight: "bold",
                        border: "none",
                        borderRadius: "10px",
                        padding: "10px 18px",
                        cursor: "pointer",
                    }}
                >
                    Log Out
                </button>
            </div>
        </div>
    );
};

export default AccountDisabled;
